/*
  Pre-order batch badge
  ---------------------
  A small pill showing how many days are left in the current pre-order batch.

  Extends <weekly-preorder-countdown> so the day count comes from the same
  schedule as the countdown bar and the product page banner. Rendered client
  side for the same reason those are: a day count baked into Liquid would go
  stale the moment the page is cached.

  weekly-preorder-countdown.js must load first (both are deferred classic
  scripts, so document order holds).
*/
(function () {
  var Base = customElements.get('weekly-preorder-countdown');
  if (!Base || customElements.get('preorder-batch-badge')) return;

  class PreorderBatchBadge extends Base {
    connectedCallback() {
      this.labelEl = this.querySelector('.js-batch-badge-label');
      this.override = (this.dataset.override || '').trim();

      if (this.override) {
        // Static text never depends on the cycle, so it stays put - and with no
        // day count behind it there is nothing to call urgent.
        if (this.labelEl) this.labelEl.textContent = this.override;
        this.removeAttribute('data-urgent');
        this.hidden = false;
        return;
      }

      this.update();
      this.start();
    }

    update() {
      var schedule = this.getSchedule(new Date());

      if (!schedule.isActive || schedule.remainingMinutes < 0) {
        this.hidden = true;
        return;
      }

      /*
        Calendar days remaining, counting today: the Monday a batch opens reads
        7 and the Sunday it closes reads 1. Rounding up is what makes the
        opening day say "7 days" rather than "6 days and change".
      */
      var days = Math.ceil(schedule.remainingMinutes / 1440);
      if (days < 1) days = 1;

      /*
        "Only" is a nudge, and a nudge spent three weeks out reads as noise. So
        the plain wording carries the batch until it is close to closing, and
        the urgent wording takes over inside the threshold.
      */
      var urgentDays = parseInt(this.dataset.urgentDays, 10);
      if (!(urgentDays > 0)) urgentDays = 3;

      var isUrgent = days <= urgentDays;
      if (isUrgent) {
        this.setAttribute('data-urgent', '');
      } else {
        this.removeAttribute('data-urgent');
      }

      var template;
      if (days === 1) {
        // The closing day. Falls back to the singular wording if the merchant
        // cleared the closing-day field.
        template = this.dataset.textLast
          || this.dataset.textOne
          || 'Pre order - Last day';
      } else if (isUrgent) {
        // Falls back to the plain wording if the urgent field was cleared.
        template = this.dataset.textMany
          || this.dataset.textFar
          || 'Pre order - Only {days} days';
      } else {
        // Falls back to the urgent wording so an unset field still says something.
        template = this.dataset.textFar
          || this.dataset.textMany
          || 'Pre order - {days} days';
      }

      this.hidden = false;
      if (this.labelEl) {
        this.labelEl.textContent = template.replace(/\{days\}/g, String(days));
      }
    }
  }

  customElements.define('preorder-batch-badge', PreorderBatchBadge);
})();
